import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { GoTools } from 'react-icons/go';

import Page from 'src/components/Page';
import agm from '../../services/agm'

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Other from './Other';
import Create from './Create';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultColors = [
  { id: 'black', name: 'Preto' },
  { id: 'blue', name: 'Azul' },
  { id: 'brown', name: 'Marrom' },
  { id: 'cyan', name: 'Oceano' },
  { id: 'gray', name: 'Cinza' },
  { id: 'green', name: 'Verde' },
  { id: 'red', name: 'Vermelho' },
  { id: 'white', name: 'Branco' },
  { id: 'yellow', name: 'Amarelo' },
  { id: 'magenta', name: 'Roxo' }
];


const defaultItem = {
  id: null,
  nome: '',
  marcador: null
}

const defaultDependencies = {
  loaded: false,
  companies: [],
  providers: [],
  teams: [],
  infrasType: [],
  infras: [],
  colors: defaultColors
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 }
];

const lauchResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Operação', field: '((item.operacao == 1) ? "Crédito" : "Débito")', size: -1, sortable: 'operacao', exportable: 0, wrap: 0 },
  { name: 'Especificação', field: '((item.especificado == 1) ? "Especificação Obrigatória" : "Livre")', size: -1, sortable: 'especificado', exportable: 0, wrap: 0 }
];

const companiesResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 50, sortable: null, exportable: 0, wrap: 0 },
  { name: 'CNPJ', field: 'item.cnpj', size: -1, sortable: 'cnpj', exportable: 0, wrap: 0 },
  { name: 'Endereço', field: 'item.endereco', size: -1, sortable: 'endereco', exportable: 0, wrap: 0 },
  { name: 'Bairro', field: 'item.bairro', size: -1, sortable: 'bairro', exportable: 0, wrap: 0 },
  { name: 'Município', field: 'item.municipio', size: -1, sortable: 'municipio', exportable: 0, wrap: 0 },
  { name: 'UF', field: 'item.uf', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'CEP', field: 'item.cep', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Ativa', field: '(item.ativa) ? "Sim" : "Não"', size: -1, sortable: null, exportable: 0, wrap: 0 }
];

const sintomeResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'SLA de Atendimento', field: 'item.slaAtendimento', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Quantidade', field: 'item.vlrAtendimento', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'SLA de Conclusao', field: 'item.slaConclusao', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Quantidade', field: 'item.vlrConclusao', size: -1, sortable: null, exportable: 0, wrap: 0 },
];

const providersResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Controlar Caixinha', field: '(item.controlado ? "Sim": "Não")', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Ativa', field: '(item.ativa ? "Sim": "Não")', size: -1, sortable: null, exportable: 0, wrap: 0 }
];

const techinicResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Departamento', field: 'item.prestadora.nome', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Ativo', field: '(item.ativo ? "Sim": "Não")', size: -1, sortable: null, exportable: 0, wrap: 0 }
];

const regionsResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Supervisor', field: 'item.supervisor', size: -1, sortable: 'supervisor', exportable: 0, wrap: 0 },
  { name: 'Cor do Marcador', field: 'item.marcador', size: -1, sortable: 'marcador', exportable: 0, wrap: 0 },
];

const infraResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Tipo de Infraestrutura', field: 'item.tipo.nome', size: -1, sortable: null, exportable: 0, wrap: 0 }
];

const pdAplicationsResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Descrição', field: 'item.descricao', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'É Item Extra na LPU', field: '(item.extra ? "Sim": "Não")', size: -1, sortable: null, exportable: 0, wrap: 0 }
];

const InfoTipoInfraResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 150, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Infraestrutura', field: '(item.infraEstrutura) ? item.infraEstrutura.nome : ""', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome da Informação', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Tipo de Entrada', field: 'getNomeTipoEntrada(item.tipoEntrada)', size: -1, sortable: 'tipoEntrada', exportable: 0, wrap: 0 },
  { name: 'Tamanho de Armazemanento', field: 'item.tamanho', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Sufixo ou Unidade de Medida', field: 'item.sufixo', size: -1, sortable: 'sufixo', exportable: 0, wrap: 0 },
  { name: 'Informação Obrigatória', field: 'showBoolean(item.obrigatorio, "Sim", "Não")', size: -1, sortable: null, exportable: 0, wrap: 0 },
];

const veiclesResultColumns = [
  { name: 'Placa', field: 'item.id', size: 200, sortable: 'id', exportable: 0, wrap: 0 },
  { name: 'Marca', field: 'item.marca', size: -1, sortable: 'marca', exportable: 0, wrap: 0 },
  { name: 'Modelo', field: 'item.modelo', size: -1, sortable: 'modelo', exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 }
];

const stocksResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Ativo', field: '(item.ativo ? "Sim": "Não")', size: -1, sortable: null, exportable: 0, wrap: 0 }
];

const faseResultColumns = [
  { name: 'Código', field: 'formatNumber(item.id, "00000")', size: 200, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'É Pendência', field: '(item.pendencia ? "Sim": "Não")', size: -1, sortable: null, exportable: 0, wrap: 0 }
];


const defaultEmptyMessage = "Nenhum Registro Foi Encontrado.";

const defaultFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const stocksFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: stocksResultColumns
};

const stocksCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: stocksResultColumns
};

const lauchFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: lauchResultColumns
};

const lauchCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: lauchResultColumns
};

const companiesFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: companiesResultColumns
};

const companiesCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: companiesResultColumns
};


const sintomeFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: sintomeResultColumns
};

const sintomeCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: sintomeResultColumns
};

const technicianFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: techinicResultColumns
};

const technicianCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: techinicResultColumns
};

const providersFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: providersResultColumns
};

const providersCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: providersResultColumns
};

const regionsFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: regionsResultColumns
};

const regionsCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: regionsResultColumns
};

const infraFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: infraResultColumns
};

const infraCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: infraResultColumns
};

const pdAplicationsFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: pdAplicationsResultColumns
};

const pdAplicationsCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: pdAplicationsResultColumns
};


const InfoTipoInfraResultFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: InfoTipoInfraResultColumns
};

const InfoTipoInfraResultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: InfoTipoInfraResultColumns
};

const veiclesFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: veiclesResultColumns
};

const veiclesCompactModes = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: veiclesResultColumns
};

const faseFullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: faseResultColumns
};

const faseCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: faseResultColumns
};


const defaultResultModes = [defaultFullMode, defaultCompactMode];
const companiesResultModes = [companiesFullMode, companiesCompactMode];
const sintomeResultModes = [sintomeFullMode, sintomeCompactMode];
const providersResultModes = [providersFullMode, providersCompactMode];
const technicianResultModes = [technicianFullMode, technicianCompactMode];
const regionsResultModes = [regionsFullMode, regionsCompactMode];
const infraResultModes = [infraFullMode, infraCompactMode];
const pdAplicationsResultModes = [pdAplicationsFullMode, pdAplicationsCompactMode];
const InfoTipoInfraResultModes = [InfoTipoInfraResultFullMode, InfoTipoInfraResultCompactMode];
const lauchResultModes = [lauchCompactMode, lauchCompactMode];
const veiclesResultModes = [veiclesCompactModes, veiclesFullMode];
const stocksCompactModes = [stocksCompactMode, stocksFullMode];
const faseCompactModes = [faseCompactMode, faseFullMode];

const defaultVisions = [
  { id: 1, name: 'Empresa Cliente', refine: 1, label: 'Nome da empresa cliente', history: 0, url: '/empresas', confirmemsg: 'Deseja excluir a empresa cliente selecionada?', deletemsg: 'Erro ao remover a empresa cliente.', updatemsg: 'Erro ao atualizar a empresa cliente.', createmsg: 'Erro ao criar a empresa cliente.', listmsg: 'Erro ao recuperar lista de empresas cliente.', columns: companiesResultModes },
  { id: 2, name: 'Categoria de Produto', refine: 1, label: 'Nome da Categoria de produto', history: 0, url: '/aplicacoes', confirmemsg: 'Deseja excluir a categoria de produto selecionada?', deletemsg: 'Erro ao remover a aplicação de produto.', updatemsg: 'Erro ao atualizar a aplicação de produto.', createmsg: 'Erro ao criar a aplicação de produto.', listmsg: 'Erro ao recuperar lista de cateorias de produto.', columns: pdAplicationsResultModes },
  { id: 3, name: 'Fornecedor de Produto', refine: 1, label: 'Nome do Fornecedor de Produto', history: 0, url: '/fornecedores', confirmemsg: 'Deseja excluir o Fornecedor de Produto selecionado?', deletemsg: 'Erro ao remover o Fornecedor de Produto.', updatemsg: 'Erro ao atualizar o Fornecedor de Produto.', createmsg: 'Erro ao criar o Fornecedor de Produto.', listmsg: 'Erro ao recuperar lista de Fornecedores de Produtos.', columns: defaultResultModes },
  { id: 5, name: 'Marca de Produto', refine: 1, label: 'Nome da Marca de Produto', history: 0, url: '/marcas', confirmemsg: 'Deseja excluir a Marca de Produto selecionado?', deletemsg: 'Erro ao remover a Marca de Produto.', updatemsg: 'Erro ao atualizar a Marca de Produto.', createmsg: 'Erro ao criar a Marca de Produto.', listmsg: 'Erro ao recuperar lista de Marcas de Produtos.', columns: defaultResultModes },
  { id: 6, name: 'Tipo de Produto', refine: 1, label: 'Nome do Tipo de Produto', history: 0, url: '/tiposproduto', confirmemsg: 'Deseja excluir o Tipo de Produto selecionado?', deletemsg: 'Erro ao remover o Tipo de Produto.', updatemsg: 'Erro ao atualizar o Tipo de Produto.', createmsg: 'Erro ao criar o Tipo de Produto.', listmsg: 'Erro ao recuperar lista o Tipos de Produtos.', columns: defaultResultModes },
  { id: 7, name: 'Unidade de Produto', refine: 1, label: 'Nome da Unidade de Produto', history: 0, url: '/unidadeproduto', confirmemsg: 'Deseja excluir a Unidade de Produto selecionado?', deletemsg: 'Erro ao remover a Unidade de Produto.', updatemsg: 'Erro ao atualizar a Unidade de Produto.', createmsg: 'Erro ao criar a Unidade de Produto.', listmsg: 'Erro ao recuperar lista de Unidades de Produtos.', columns: defaultResultModes },
  { id: 4, name: 'Compartimento de Estoque', refine: 1, label: 'Nome do Compartimento de Estoque', history: 0, url: '/estoques', confirmemsg: 'Deseja excluir o Compartimento de Estoque selecionado?', deletemsg: 'Erro ao remover o Compartimento de Estoque.', updatemsg: 'Erro ao atualizar o Compartimento de Estoque.', createmsg: 'Erro ao criar o Compartimento de Estoque.', listmsg: 'Erro ao recuperar lista de Compartimentos de Estoque.', columns: stocksCompactModes },
  { id: 8, name: 'Categoria de Ocorrência', refine: 1, label: 'Nome da Categoria de Ocorrencia', history: 0, url: '/categorias', confirmemsg: 'Deseja excluir a Categoria de Ocorrencia selecionada?', deletemsg: 'Erro ao remover a Categoria de Ocorrencia.', updatemsg: 'Erro ao atualizar a Categoria de Ocorrência.', createmsg: 'Erro ao criar a Categoria de Ocorrência.', listmsg: 'Erro ao recuperar lista de Categorias de Ocorrências.', columns: defaultResultModes },
  { id: 9, name: 'Local de Sintoma de Ocorrência', refine: 1, label: 'Nome do Local de Sintoma de Ocorrencia', history: 0, url: '/locais', confirmemsg: 'Deseja excluir o Local de Sintoma de Ocorrencia selecionado?', deletemsg: 'Erro ao remover o Local de Sintoma de Ocorrencia.', updatemsg: 'Erro ao atualizar o Local de Sintoma de Ocorrência.', createmsg: 'Erro ao criar o Local de Sintoma de Ocorrência.', listmsg: 'Erro ao recuperar lista de Locais de Sintomas de Ocorrências.', columns: defaultResultModes },
  { id: 10, name: 'Orcamentista de Ocorrência', refine: 1, label: 'Nome do Orcamentista de Ocorrencia', history: 0, url: '/orcamentistas', confirmemsg: 'Deseja excluir o Orcamentista de Ocorrencia selecionado?', deletemsg: 'Erro ao remover o Orcamentista de Ocorrencia.', updatemsg: 'Erro ao atualizar o Orcamentista de Ocorrencia.', createmsg: 'Erro ao criar o Orcamentista de Ocorrência.', listmsg: 'Erro ao recuperar lista de Orcamentistas de Ocorrências.', columns: defaultResultModes },
  { id: 11, name: 'Sintoma de Ocorrência', refine: 1, label: 'Nome do Sintoma de Ocorrencia', history: 0, url: '/sintomas', confirmemsg: 'Deseja excluir o Sintoma de Ocorrencia selecionado?', deletemsg: 'Erro ao remover o Sintoma de Ocorrencia.', updatemsg: 'Erro ao atualizar o Local de Sintoma de Ocorrência.', createmsg: 'Erro ao criar o Sintoma de Ocorrência.', listmsg: 'Erro ao recuperar lista de Sintomas de Ocorrências.', columns: sintomeResultModes },
  { id: 12, name: 'Departamento', refine: 1, label: 'Nome do Departamento', history: 0, url: '/prestadoras', confirmemsg: 'Deseja excluir o Departamento selecionado?', deletemsg: 'Erro ao remover o departamento.', updatemsg: 'Erro ao atualizar o departamento.', createmsg: 'Erro ao criar o departamento.', listmsg: 'Erro ao recuperar lista do departamento.', columns: providersResultModes },
  { id: 13, name: 'Técnico do Departamento', refine: 1, label: 'Nome do Técnico do Departamento', history: 0, url: '/tecnicos', confirmemsg: 'Deseja excluir o Técnico do Departamento?', deletemsg: 'Erro ao remover o Técnico do Departamento.', updatemsg: 'Erro ao atualizar o Técnico do Departamento.', createmsg: 'Erro ao criar o Técnico do Departamento.', listmsg: 'Erro ao recuperar lista de Técnicos dos Departamentos.', columns: technicianResultModes },
  { id: 22, name: 'Veículos', refine: 1, label: 'Nome do Veículo', history: 0, url: '/veiculos', confirmemsg: 'Deseja excluir o Veículo selecionado?', deletemsg: 'Erro ao remover o Veículo.', updatemsg: 'Erro ao atualizar o Veículo.', createmsg: 'Erro ao criar o Veículo.', listmsg: 'Erro ao recuperar lista de Veículos.', columns: veiclesResultModes },
  { id: 14, name: 'Engenheiro de Unidade', refine: 1, label: 'Nome do Engenheiro de Unidade', history: 0, url: '/engenheiros', confirmemsg: 'Deseja excluir o Engenheiro de Unidade selecionado?', deletemsg: 'Erro ao remover o Engenheiro de Unidade.', updatemsg: 'Erro ao atualizar o Engenheiro de Unidade.', createmsg: 'Erro ao criar o Engenheiro de Unidade.', listmsg: 'Erro ao recuperar lista de Engenheiros de Unidades.', columns: defaultResultModes },
  { id: 16, name: 'Rota de Manutenção de Unidade', refine: 1, label: 'Nome da Rote de Manutenção de Unidade', history: 0, url: '/regioes', confirmemsg: 'Deseja excluir a Rota de Manutenção de Unidade selecionado?', deletemsg: 'Erro ao remover a Rota de Manutenção de Unidade.', updatemsg: 'Erro ao atualizar a Rota de Manutenção de Unidade.', createmsg: 'Erro ao criar a Rota de Manutenção de Unidade.', listmsg: 'Erro ao recuperar lista de Rotas de Manutenção de Unidades.', columns: regionsResultModes },
  { id: 15, name: 'Equipe de Manutenção de Unidade', refine: 1, label: 'Nome de Equipe de Unidade', history: 0, url: '/equipes', confirmemsg: 'Deseja excluir a Equipe de Unidade selecionado?', deletemsg: 'Erro ao remover a Equipe de Unidade.', updatemsg: 'Erro ao atualizar a Equipe de Unidade.', createmsg: 'Erro ao criar a Equipe de Unidade.', listmsg: 'Erro ao recuperar lista de Equipes de Unidades.', columns: defaultResultModes },
  { id: 17, name: 'Gerenciadora de Manutenção de Unidade', refine: 1, label: 'Nome da Gerenciadora', history: 0, url: '/gerenciadoras', confirmemsg: 'Deseja excluir a Gerenciadora selecionado?', deletemsg: 'Erro ao remover a Gerenciadora.', updatemsg: 'Erro ao atualizar a Gerenciadora.', createmsg: 'Erro ao criar a Gerenciadora.', listmsg: 'Erro ao recuperar lista de Gerenciadoras.', columns: defaultResultModes },
  { id: 20, name: 'Tipo de Infraestrutura', refine: 1, label: 'Nome do Tipo de Infraestrutura', history: 0, url: '/tiposinfra', confirmemsg: 'Deseja excluir o tipo de infraestrutura selecionada?', deletemsg: 'Erro ao remover o tipo de infraestrutura.', updatemsg: 'Erro ao atualizar o tipo de infraestrutura.', createmsg: 'Erro ao criar tipo de infraestrutura.', listmsg: 'Erro ao recuperar lista de tipos de infraestruturas.', columns: defaultResultModes },
  { id: 19, name: 'Informação de Infraestrutura de Unidade', refine: 1, label: 'Nome da Informação de Infraestrutura de Unidade', history: 0, url: '/infrasinfos', confirmemsg: 'Deseja excluir a informação de infraestrutura de Unidade selecionada?', deletemsg: 'Erro ao remover a informação de infraestrutura de Unidade.', updatemsg: 'Erro ao atualizar a informação de infraestrutura de Unidade.', createmsg: 'Erro ao criar a informação de infraestrutura de Unidade.', listmsg: 'Erro ao recuperar lista de informações de infraestruturas de Unidade.', columns: InfoTipoInfraResultModes },
  { id: 18, name: 'Infraestrutura de Unidade', refine: 1, label: 'Nome da Infraestrutura de Unidade', history: 0, url: '/infraestruturas', confirmemsg: 'Deseja excluir a infraestrutura selecionada?', deletemsg: 'Erro ao remover a infraestrutura.', updatemsg: 'Erro ao atualizar a infraestrutura.', createmsg: 'Erro ao criar infraestrutura.', listmsg: 'Erro ao recuperar lista de infraestruturas.', columns: infraResultModes },
  { id: 21, name: 'Tipo de Lançamento na Caixinha', refine: 1, label: 'Nome do Tipo de Lançamento', history: 0, url: '/tiposlancamento', confirmemsg: 'Deseja excluir o tipo de Lançamento selecionado?', deletemsg: 'Erro ao remover o tipo de Lançamento.', updatemsg: 'Erro ao atualizar o tipo de Lançamento.', createmsg: 'Erro ao criar tipo de Lançamento.', listmsg: 'Erro ao recuperar lista de tipos de Lançamentos.', columns: lauchResultModes },
  { id: 23, name: 'Fase ATM', refine: 1, label: 'Fase ATM', history: 0, url: '/faseatm', confirmemsg: 'Deseja excluir a fase ATM selecionada?', deletemsg: 'Erro ao remover o tipo de Lançamento.', updatemsg: 'Erro ao atualizar o tipo de Lançamento.', createmsg: 'Erro ao criar tipo de Lançamento.', listmsg: 'Erro ao recuperar lista de Fases da ATM.', columns: faseCompactModes },
  { id: 24, name: 'Status do Cliente', refine: 1, label: 'Status do Cliente', history: 0, url: '/statuscliente', confirmemsg: 'Deseja excluir o Status do Cliente selecionado?', deletemsg: 'Erro ao remover o tipo de Lançamento.', updatemsg: 'Erro ao atualizar a lista de Status do Cliente.', createmsg: 'Erro ao criar tipo de Lançamento.', listmsg: 'Erro ao recuperar lista de Status do Cliente.', columns: defaultResultModes },
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const Others = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = (item) => {
    setItem(item);
    updateDependencies(item);
    setOpenEditionDialog(true);
  }

  const openCreation = async (item) => {
    setItem(item);
    updateDependencies(item);
    setOpenCreationDialog(true);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: vision.name,
      message: vision.confirmemsg,
      warn: 'Esta ação pode interferir em vários pontos do sistema.',
      details: ['Os dados excluídos não poderam ser recuperados.']
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    refreshItems();
  }

  const updateValues = (values) => {
    agm.put(vision.url + '/' + values.id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: vision.updatemsg, detail: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    agm.post(vision.url, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: vision.createmsg, detail: error.message });
      setOpenAlert(true);
    })
  };

  const updateDependencies = async (values) => {
    if (vision.id == 13) {
      agm.get('/prestadoras', {}, {}).then((response) => {
        if (!response.data.error) {
          setDependencies({ ...dependencies, providers: response.data });
        } else {
          setMessage(response.data);
          setOpenAlert(true);
        }
      }).catch((error) => {
        console.error(error);
        setMessage({ error: true, fatal: true, message: vision.listmsg, detail: error.message });
        setOpenAlert(true);
      })
    }
    if (vision.id == 18) {
      agm.get('/tiposinfra', {}, {}).then((response) => {
        if (!response.data.error) {
          setDependencies({ ...dependencies, infrasType: response.data });
        } else {
          setMessage(response.data);
          setOpenAlert(true);
        }
      }).catch((error) => {
        console.error(error);
        setMessage({ error: true, fatal: true, message: vision.listmsg, detail: error.message });
        setOpenAlert(true);
      })
    }
    if (vision.id == 19) {
      agm.get('/infraestruturas', {}, {}).then((response) => {
        if (!response.data.error) {
          setDependencies({ ...dependencies, infras: response.data });
        } else {
          setMessage(response.data);
          setOpenAlert(true);
        }
      }).catch((error) => {
        console.error(error);
        setMessage({ error: true, fatal: true, message: vision.listmsg, detail: error.message });
        setOpenAlert(true);
      })
    }
  };

  const deleteValues = (values) => {
    agm.delete(vision.url + '/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: vision.deletemsg, detail: error.message });
      setOpenAlert(true);
    })
  };
  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    agm.post(vision.url + '/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: vision.listmsg, detail: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    setResultModes(vision.columns);
    agm.post(vision.url + '/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: vision.listmsg, detail: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    agm.post(vision.url + '/historico', { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / filter.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : filter.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);

        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: vision.listmsg, detail: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title={vision.name}
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={GoTools}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <Other item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          vision={vision}
        />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          vision={vision}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={GoTools}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                dependencies={dependencies}
              />
            </CardContent>
          </Card>
        </Box>

      </Container>
    </Page>
  );
};

export default Others;
